<template>
  <v-layout align-start justify-center row date-range-selector>
    <v-flex class="item elevation-5">
      <dash-date-picker v-model="fromDate" :range-control="dateValue.from" label="Date From" v-on:date-picked="updateFromDate" :full-date="dateValue" identifier="dateFrom"></dash-date-picker>
    </v-flex>
    <v-flex class="item elevation-5">
      <dash-date-picker v-model="toDate" :range-control="dateValue.to" label="Date To" v-on:date-picked="updateToDate" :full-date="dateValue" identifier="dateTo"></dash-date-picker>
    </v-flex>
    <v-flex class="item elevation-5 date-success">
      <v-btn class="mt-3" color="success" v-on:click="updateDates">Go</v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import DashDatePicker from './DashDatePicker';
import moment from "moment";

export default {
  name: "DateRangeSelector",
  props: {
    dateRange: {
      type: Object
    },
    bus: {
      type: Object
    }
  },
  data() {
    return {
      dateValue: {
        to: '',
        from: ''
      }
    }
  },
  components: {
    DashDatePicker
  },
  computed: {
    fromDate: {
      get: function() {
        return this.dateValue.from;
      },
      set: function(value) {
        this.dateValue.from = value;
      }
    },
    toDate: {
      get: function() {
        return this.dateValue.to;
      },
      set: function(value) {
        this.dateValue.to = value;
      }
    }
  },
  methods: {
    updateDates() {
      this.$emit('dates-picked', this.dateValue);
    },
    updateFromDate(value) {
      this.fromDate = value
      this.$store.state.Dashboard.widgetConfig.dateRange.from = this.fromDate;
    },
    updateToDate(value) {
      this.toDate = value;
      this.$store.state.Dashboard.widgetConfig.dateRange.to = this.toDate;
    },
    barClicked(event) {
      if (typeof event.name === "string") {
        const selectedDate = moment(event.name, 'YYYY-MM');

        this.dateValue.from = selectedDate.startOf('month').format('YYYY-MM-DD');
        this.dateValue.to = selectedDate.endOf('month').format('YYYY-MM-DD');

        this.updateDates();
      }
    }
  },
  created() {
    this.dateValue = this.dateRange;

    this.bus.$on('bar-clicked', (event) => {
      if (typeof event.viewType === "string") {
        switch (event.viewType) {
          case 'date_range':
            this.barClicked(event);
        }
      }
    })
  }
}
</script>

<style scoped>

</style>
